import { useEffect, useRef, useState } from 'react';
import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';
import TrustpilotStars from './TrustpilotStars';

const ReviewsHorizontalElement = ({ element }) => {
    const { replaceTemplates } = useOnboarding();
    const scrollWrapperRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const style = applyStyles(element);

    useEffect(() => {
        if (!element.reviews || element.reviews.length <= 1) return;

        const scrollToCard = (index) => {
            if (scrollWrapperRef.current) {
                const cardWidth = scrollWrapperRef.current.querySelector('.review-card')?.offsetWidth || 0;
                const gap = 16;
                const scrollPosition = (cardWidth + gap) * index;

                scrollWrapperRef.current.scrollTo({
                    left: scrollPosition,
                    behavior: 'smooth'
                });
            }
        };

        // Строго каждые 5 секунд переключаем на следующую карточку
        const interval = setInterval(() => {


            setCurrentIndex(prevIndex => {

                const nextIndex = (prevIndex + 1);
                scrollToCard(nextIndex);
                return nextIndex;
            });
        }, 5300);

        return () => {
            clearInterval(interval);
        };
    }, [element.reviews]);

    if (!element.reviews || !Array.isArray(element.reviews)) {
        return null;
    }

    return (
        <div className="element-reviews-horizontal" style={style}>
            <div className="reviews-scroll-wrapper" ref={scrollWrapperRef}>
                {element.reviews.map((review, index) => (
                    <div key={index} className="review-card" data-index={index}>
                        {(review.starsCount !== undefined || review.name) && (
                            <div className="review-header">
                                {review.starsCount !== undefined && (
                                    <TrustpilotStars count={parseInt(review.starsCount) || 5} />
                                )}
                                {review.name && (
                                    <div className="review-name">
                                        {replaceTemplates(review.name)}
                                    </div>
                                )}
                            </div>
                        )}
                        {review.title && (
                            <div className="review-title">
                                {replaceTemplates(review.title)}
                            </div>
                        )}
                        {review.text && (
                            <div className="review-text">
                                {replaceTemplates(review.text)}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReviewsHorizontalElement;

